import { render, staticRenderFns } from "./SummaryDashboard.vue?vue&type=template&id=0bb127ae&scoped=true&"
import script from "./SummaryDashboard.vue?vue&type=script&lang=js&"
export * from "./SummaryDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SummaryDashboard.vue?vue&type=style&index=0&id=0bb127ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb127ae",
  null
  
)

export default component.exports